<script>
    import { page, modal } from '../store/nav';
    import { fade, fly } from 'svelte/transition';

    export let open = false;
    export let anchor = 'bottom';
</script>
{#if open}
  <div class="modal z-50 fixed w-screen h-screen top-0 left-0 flex items-center">
    <div transition:fade="{{ duration: 200 }}" class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50" on:click={modal.close}></div>
    {#if anchor == 'bottom'}
      <div transition:fly="{{ y: 200, duration: 100 }}" class="bg-secondary fixed bottom-0 left-0 w-full max-h-[725px] mx-auto rounded-t-3xl shadow-xl z-50 p-7">
        <slot name="body" />
      </div>  
    {:else}
      <div transition:fly="{{ y: -200, duration: 100 }}" class="bg-secondary fixed top-0 left-0 w-full max-h-[725px] mx-auto rounded-b-3xl shadow-xl z-50 p-7">
        <slot name="body" />
      </div>
    {/if}
  </div>
{/if}